// extracted by mini-css-extract-plugin
export default {"sectionTitle_container":"sectionTitle_sectionTitle_container__OKzLz"};